module.exports = __webpack_public_path__ + "static/media/[Clean] Joel Adams - Coffee.468fad7e.mp3";